import { c as _c } from "react/compiler-runtime";
import { FALLBACK_IMAGE_SM, LazyImage } from "@website/ui/lazy-image";
import { ReserveCommentPicturesTypes } from "@website/widget/reserve-comment/reserve-comment-pictures/reserve-comment-pictures.types";
import { useRouter } from "next/router";
export const ReserveCommentPictures = t0 => {
  const $ = _c(11);
  const {
    id,
    gallery
  } = t0;
  const router = useRouter();
  let t1;
  if ($[0] !== router) {
    t1 = (item, id_0) => router.push({
      pathname: router.pathname,
      query: {
        ...router.query,
        modal: "gallery-comment",
        item,
        id: id_0
      }
    }, undefined, {
      shallow: true,
      scroll: false
    });
    $[0] = router;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onClick = t1;
  let t2;
  if ($[2] !== gallery || $[3] !== id || $[4] !== onClick) {
    let t3;
    if ($[6] !== id || $[7] !== onClick) {
      t3 = (picture, index) => <LazyImage className="h-[60px] w-[74px] cursor-pointer rounded-lg" fallback={FALLBACK_IMAGE_SM.src} id={String(picture?.id)} onClick={() => onClick(String(index), id)} src={picture?.media} />;
      $[6] = id;
      $[7] = onClick;
      $[8] = t3;
    } else {
      t3 = $[8];
    }
    t2 = gallery.map(t3);
    $[2] = gallery;
    $[3] = id;
    $[4] = onClick;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[9] !== t2) {
    t3 = <div className="flex flex-row flex-wrap justify-start gap-4">{t2}</div>;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};